import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-demo',
  imports: [],
  templateUrl: './demo.component.html',
  styleUrl: './demo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoComponent implements OnInit {
  public iframeUrl: SafeResourceUrl | undefined;
  public logoUrl: SafeResourceUrl | undefined;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
  ) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.origin}/embed/${this.route.snapshot.data['demoUuid']}`,
    );

    this.logoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.route.snapshot.data['demoUuid'] != '3e557734-031a-410d-8c0a-93405a0633d6'
        ? 'https://threed-server.s3.ap-northeast-2.amazonaws.com/media/logo/%E8%8F%93%E6%96%A4%E6%9A%A0%E1%84%90%E1%85%B2%E1%86%B7_20240701133352.png'
        : 'https://threed-server.s3.ap-northeast-2.amazonaws.com/media/logo/%E1%84%8C%E1%85%A1%E1%84%89%E1%85%A1%E1%86%AB+2.png',
    );
  }
}
